import { IPanel, LinkActionSchema } from "smarthub-common";

export const chatPanel: IPanel = {
  $id: "panel.chat",
  $schema: "https://ics.ai/smarthub/panel",
  group: "panels.intranet",
  description: "Chat transcript and controls",
  title: "Chat",
  shortTitle: "chat",
  icon: {
    name: "Chat",
  },
  order: 1,
  initialFocus: "chat-controls",
  navigation: "none",
  menu: {
    $id: "component.chat-menu",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-menu",
    title: "Chat menu",
    description: "Choose display settings",
    props: {
      showLauncher: false,
    },
  },
  pages: {
    $id: "component.chat-pages",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-pages",
    title: "Chat pages",
    description: "Chat pages",
    props: {
      config: {
        pages: [],
      },
    },
  },
  launcher: {
    $id: "component.chat-launcher",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-launcher",
    title: "Chat launcher",
    description: "Chat launcher",
    props: {
      enabled: false,
      config: {},
    },
  },
  splash: {
    $id: "component.chat-splash",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat splash",
    description: "Chat splash",
    template: "component.chat-splash",
    props: {
      enabled: true,
      mode: "implicit",
      cacheLocation: "session",
      version: "1.0",
      sessionKey: "customer.ai-flex-chat-tnc-acceptance",
      config: {
        html: {
          en: '<p>Hello, I\'m ELLIS. To start a chat, please choose \'Continue\' to confirm you have read and understood our <a href="https://www.lewes-eastbourne.gov.uk/article/1342/Privacy-notice" target="_blank"><strong>Privacy Policy.</strong></a></p><p>I respond best if the question is phrased clearly in four or more words, but not too long. If you do not receive the answer you are looking for at first, try re-phrasing the question.</p><p>I am continually learning, so please provide your feedback when prompted. The council will use this information to improve your future chatbot experience.</p><p>More information can be found on our <a href="https://www.lewes-eastbourne.gov.uk/ellis" alt="Lewes & Eastborne">website</a>.</p>',
        },
        container: {
          margin: "0px",
          padding: "20px",
          backgroundColor: "#fff",
          textColor: "#333",
          fontSize: "18px",
        },
        buttons: {
          primaryButtonBackgroundColor: "#486c7a",
          primaryButtonHoverBackgroundColor: "#333",
          primaryButtonTextColor: "white",
          primaryButtonHoverTextColor: "white",
          primaryButtonPadding: "20px",
          primaryButtonFontSize: "18px",
          secondaryButtonBackgroundColor: "white",
          secondaryButtonHoverBackgroundColor: "white",
          secondaryButtonTextColor: "black",
          secondaryButtonHoverTextColor: "black",
          secondaryButtonPadding: "20px",
          secondaryButtonFontSize: "18px",
        },
      },
    },
  },
  header: {
    $id: "component.chat-header",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat header",
    description: "Chat header",
    template: "component.chat-header",
  },
  footer: {
    $id: "component.chat-footer",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat footer",
    description: "Chat footer",
    template: "component.chat-footer",
    props: {
      actions: [
        {
          name: {
            en: "privacy",
          },
          title: "",
          shortTitle: {
            en: "Privacy Statement",
          },
          description: "",
          action: {
            $id: "",
            $schema: LinkActionSchema,
            uri: "https://www.lewes-eastbourne.gov.uk/article/1342/Privacy-notice",
            target: "_self",
          },
        },
      ],
    },
  },
  templates: [
    {
      $id: "template.chat",
      $schema: "https://ics.ai/smarthub/template",
      description: "Felix chat transcript and controls",
      title: "Felix chat",
      shortTitle: "Chat",
      group: "templates.intranet",
      tabs: [
        {
          $id: "layout.chat",
          $schema: "https://ics.ai/smarthub/tab",
          description: "Felix chat transcript and controls.",
          group: "tabs.intranet",
          title: "Chat",
          shortTitle: "Chat",
          icon: {
            name: "Chat",
          },
          body: {
            grid: {
              tokens: {
                padding: "none",
              },
              rows: [
                {
                  responsive: {
                    sm: { scroll: true, stretch: true },
                  },
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.main",
                        },
                      ],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.controls",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            zones: [
              {
                id: "zone.main",
                components: [
                  {
                    $id: "component.chat-transcript",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat conversation",
                    template: "component.chat-transcript",
                  },
                ],
              },
              {
                id: "zone.controls",
                components: [
                  {
                    $id: "component.chat-controls",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat controls",
                    template: "component.chat-controls",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
